/**
 * Generated runtime TestId mirror for frontend/src/pages/AutoAssignRuleExecutions.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const AutoAssignRuleExecutionsTestIds = {
  autoAssignRuleExecutions: "auto-assign-rule-executions",
  btnClearRuleFilter: "btn-clear-rule-filter",
  colAdded: "col-added",
  colDuration: "col-duration",
  colExecutedAt: "col-executed-at",
  colMatched: "col-matched",
  colRemoved: "col-removed",
  colRule: "col-rule",
  colStatus: "col-status",
  linkRuleDetail: (exec_ruleId: string) => `link-rule-detail-${exec_ruleId}`,
  linkRuleDetailPrefix: () => "link-rule-detail-" as TestIdPrefix
} as const;
